import { Injectable } from "@angular/core";
import { CrudService } from "../crud.service";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class AppointmentsService extends CrudService {
    constructor(httpClient: HttpClient) {
        super(httpClient, "patient/my-appointments");
    }

    cancel(item: any) {
        const t = this;
        return this.httpClient
            .post(environment.endpoint + "/cancel", item)
            .pipe(map((res: any) => res || []));
    }

    makeAppointment(appointment: any, file?: File | null): Observable<any> {
        const formData = new FormData();

        // Partea JSON ca string; backend-ul o primește ca String și o parsează cu ObjectMapper
        formData.append("appointment", JSON.stringify(appointment));

        if (file) {
            formData.append("file", file, file.name);
        }

        return this.httpClient.post(
            environment.endpoint + "appointments/make-appointments",
            formData,
        );
    }
}
